<template>
    <div><newartical-component/></div>
</template>

<script>
import newarticalComponent from '../../components/bolg/newartical.component.vue'
export default {
  components: { newarticalComponent },
    
}
</script>